import React, { useState } from "react";
import { ThemeProvider } from "@material-ui/styles";
import theme from "./constants/theme";
import { onSubmitForm, onVerifyRecaptcha } from "./api/BaseAPI";
import TSAForm from "./components/TSAForm";
import ConfirmationModal from "./components/ConfirmationModal";
import Header from "./views/Header";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import ReactGA from "react-ga";
import { format } from "date-fns";

const App = () => {
  ReactGA.initialize("UA-87674982-6");
  ReactGA.pageview(window.location.pathname + window.location.search);

  const [form, setForm] = useState({
    airport: -1,
    firstName: "",
    lastName: "",
    email: "",
    emailConfirm: "",
    phone: "",
    streetAddress: "",
    city: "",
    zip: "",
    state: "",
    country: 235,
    // incidentType: 1,
    category: -1,
    date: "",
    time: "",
    location: -1,
    airline: "",
    flight: "",
    locationDescription: "",
    itemDescription: "",
    imageFile: null,
  });

  const { executeRecaptcha } = useGoogleReCaptcha();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [claimId, setClaimId] = useState(-1);

  const onSubmit = async (values) => {
    setForm(values);

    try {
      const recaptchaToken = await executeRecaptcha("onSubmit");
      const res = await onVerifyRecaptcha(recaptchaToken);
      if (res.status !== 1) {
        throw new Error("Recaptcha error!");
      }
      values.token = recaptchaToken;
      values.incidentType = 1; // lost incident type
      values.date = format(values.date, "yyyy-MM-dd");
      values.time = format(values.time, "hh:mm");
      if (values.imageFile) {
        values.imageFile = await toBase64(values.imageFile);
      }
      const query = window.location.search.substring(1);
      const trackingPair = query.split("=");
      if (trackingPair && trackingPair.length > 0 && trackingPair[0] === "t") {
        values.t = trackingPair[1];
      }
      const referrer = document.referrer;
      if (referrer) {
        const encodedReferrer = Buffer.from(referrer).toString("base64");
        values.r = encodedReferrer;
      }
      console.log(JSON.stringify(values));
      const response = await onSubmitForm(values, recaptchaToken);
      if (response.status !== 1) {
        setHasError(true);
        ReactGA.exception({
          description: "Server error! Unable to submit form!",
          fatal: true,
        });
      } else {
        setClaimId(response.data.id);
        setHasError(false);
        ReactGA.event({
          category: "Submit",
          action: "Form submitted successfully!",
        });
      }
    } catch (error) {
      setHasError(true);
      ReactGA.exception({
        description: "An error ocurred when submitting the form",
        fatal: true,
      });
    }
    onToggleModal();
  };

  const onToggleModal = () => {
    if (isModalOpen) {
      !hasError ? window.open("https://traista.com/", "_self") : "";
    }
    setIsModalOpen(!isModalOpen);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  return (
    <div className="container">
      <ThemeProvider theme={theme}>
        <div
          style={{
            display: "flex",
            flexGrow: 1,
          }}
        >
          <Header
            title="Traista"
            subtitle1="Lost and Found"
            subtitle2="Your TSA partner for lost items at airports"
          />
        </div>
      </ThemeProvider>
      <TSAForm
        airport={form.airport}
        firstName={form.firstName}
        lastName={form.lastName}
        email={form.email}
        emailConfirm={form.emailConfirm}
        phone={form.phone}
        streetAddress={form.streetAddress}
        city={form.city}
        zip={form.zip}
        state={form.state}
        country={form.country}
        // incidentType={form.incidentType}
        category={form.category}
        date={form.date}
        time={form.time}
        location={form.location}
        airline={form.airline}
        flight={form.flight}
        locationDescription={form.locationDescription}
        itemDescription={form.itemDescription}
        imageFile={form.imageFile}
        onSubmit={onSubmit}
      />
      <ConfirmationModal
        isOpen={isModalOpen}
        toggle={onToggleModal}
        hasError={hasError}
        claimId={claimId}
      />
    </div>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js